import store from '@/store'
import ModuleBase from '@/modules/fieldcrews/components/ModuleBase'
import FieldcrewsDashboard from '@/modules/fieldcrews/views/dashboard/Dashboard'
import FieldRoute from '@/modules/fieldcrews/views/route/FieldRoute'
import ProjectRoute from '@/modules/fieldcrews/views/route/ProjectRoute'
import DetailBase from '@/modules/fieldcrews/components/irrigationDetail/Base'
import IrrigationFieldDetailOverview from '@/modules/fieldcrews/components/irrigationDetail/Overview'


const routes = [
  {
    path: '/field-crews/',
    component: ModuleBase,
    meta: { appKey: 'fieldcrews' },
    children: [
      {
        path: 'dashboard',
        component: FieldcrewsDashboard,
        name: 'FieldcrewsDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'route/:id',
        component: FieldRoute,
        name: 'FieldRoute'
      },
      {
        path: 'group/:id',
        component: ProjectRoute,
        name: 'ProjectRoute'
      },
      {
        path: 'details/:id/',
        component: DetailBase,
        children: [
          {
            path: 'overview',
            name: 'IrrigationFieldDetailOverview',
            component: IrrigationFieldDetailOverview
          }
        ]
      }
    ]
  }
]

export default routes
